import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isValid } from 'date-fns';

import { DatePickerInput } from '../../components';

import messages from './messages';
import './timeframe.css';

class Timeframe extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    filterEvents: PropTypes.func.isRequired,
    timeframe: PropTypes.object,
  };

  state = {
    dateFrom: undefined,
    dateTo: undefined,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.timeframe.dateFrom !== this.props.timeframe.dateFrom) {
      const dateFrom = this.props.timeframe.dateFrom && new Date(this.props.timeframe.dateFrom);
      this.setState({ dateFrom });
    }
    if (prevProps.timeframe.dateTo !== this.props.timeframe.dateTo) {
      const dateTo = this.props.timeframe.dateTo && new Date(this.props.timeframe.dateTo);
      this.setState({ dateTo });
    }
  }

  validateDate = (date, id) => {
    let timestamp = date;
    if (id === 'dateFrom' && date < new Date()) timestamp = new Date();
    if (id === 'dateTo' && this.state.dateFrom && timestamp < this.state.dateFrom) timestamp = this.state.dateFrom;
    return timestamp;
  };

  emptyDate = (date, name, id) => {
    if (!date && this.state[id] !== date) {
      this.setState({ [id]: date });
      this.props.filterEvents(name, date, id);
      return true;
    }
    return false;
  };

  handleDayClick = (date, disabled, name, id) => {
    if (disabled) return;
    if ((!date || !isValid(date)) && this.state[id] === date) return;
    if (this.emptyDate(date, name, id)) return;
    let timestamp = this.validateDate(date, id);
    timestamp = new Date(timestamp.getTime() + timestamp.getTimezoneOffset() * 60000);
    this.setState({ [id]: timestamp });
    if (id === 'dateFrom') timestamp.setHours(0, 0, 0, 0, 0);
    if (id === 'dateTo') timestamp.setHours(23, 59, 59, 0);
    this.props.filterEvents(name, timestamp.getTime(), id);
  };

  handleOnBlur = (date, name, id) => {
    if (!date || !date.setHours) return;
    const timestamp = this.validateDate(date, id);
    if (date === timestamp) return;
    return this.handleDayClick(timestamp, false, name, id);
  };

  render() {
    if (this.props.hide) return null;
    const { dateFrom, dateTo } = this.state;
    const today = new Date();
    return (
      <div>
        <strong className="date-hint">
          <FormattedMessage {...messages.datesearch} />
        </strong>
        <div className="date-inputs">
          <DatePickerInput
            aria-label="Event Start Date"
            data-cy="filter-date-start"
            onDayChange={(date, { disabled }) => this.handleDayClick(date, disabled, 'timeFrame.startDateTime', 'dateFrom')}
            onBlur={(date) => this.handleOnBlur(date, 'timeFrame.startDateTime', 'dateFrom')}
            disabledDays={[{ before: today }]}
            date={dateFrom}
            selectedDays={dateFrom}
            initialMonth={dateFrom}
            maxLength={10}
          />{' '}
          to
          <DatePickerInput
            aria-label="Event End Date"
            data-cy="filter-date-end"
            onDayChange={(date, { disabled }) => this.handleDayClick(date, disabled, 'timeFrame.endDateTime', 'dateTo')}
            onBlur={(date) => this.handleOnBlur(date, 'timeFrame.endDateTime', 'dateTo')}
            disabledDays={[{ before: dateFrom ? dateFrom : today }]}
            date={dateTo}
            selectedDays={dateTo}
            initialMonth={dateTo}
            maxLength={10}
          />
        </div>
      </div>
    );
  }
}
export default injectIntl(Timeframe);
